/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CAS_MOVEMENTS_ITEM = {
  id: 'movements',
  screenId: 'fin-cas-movements',
  label: 'Movimientos de caja',
  description: 'Consultá el saldo y los movimientos de efectivo de cada caja.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá operás el efectivo del día: consultás movimientos y saldo, abrís o cerrás la caja, registrás traspasos y cargás cobros o pagos en efectivo.',
      },
      {
        title: 'Paso 1 — Elegir la caja y el período',
        fields: [
          {
            label: 'Selector de caja',
            description: 'Elegí qué caja querés consultar. Solo aparecen las cajas a las que tenés acceso.',
          },
          {
            label: 'Fecha desde / Fecha hasta',
            description: 'Rango de fechas de los movimientos. Al cambiar una fecha se actualiza la lista.',
          },
          {
            label: 'Saldo',
            description: 'Monto en efectivo según el sistema al cierre del período mostrado.',
          },
        ],
        paragraphs: [
          'Si no hay cajas habilitadas, el mensaje indica que debés crearlas desde «Cajas» en el menú lateral.',
        ],
      },
      {
        title: 'Paso 2 — Abrir o cerrar la caja',
        bullets: [
          'Candado verde abierto — la caja está abierta. Tocá para cerrarla.',
          'Candado rojo cerrado — la caja está cerrada. Tocá para abrirla.',
        ],
        paragraphs: [
          'Se abre una ventana con el saldo según el sistema y un campo para el monto que contaste en efectivo.',
          'Completá también las observaciones si querés dejar una nota.',
          'Si el monto contado coincide con el sistema, confirmá directamente.',
          'Si hay diferencia, el sistema avisa si es un faltante o un sobrante y pide confirmación. Esas diferencias se imputan a los centros configurados en la caja (ver ayuda de «Cajas»).',
        ],
      },
      {
        title: 'Paso 3 — Leer la lista de movimientos',
        bullets: [
          'Columnas: Fecha, Descripción, Usuario, Hora, Monto y Saldo.',
          'Tocá una fila para ver el detalle del movimiento o comprobante asociado.',
          'Algunos movimientos manuales pueden eliminarse desde la grilla (ícono de papelera).',
          'Usá las flechas de la lista para ver más movimientos.',
        ],
      },
      {
        title: 'Accesos del menú lateral',
        bullets: [
          'Movimientos — vuelve a esta vista principal.',
          'Actualizar — recarga la lista con los filtros actuales.',
          'Agregar movimiento — traspaso entre cajas o entre caja y banco.',
          'Cajas — alta de cajas e imputaciones de faltantes y sobrantes.',
          'Cobros — carga un recibo de cobro con efectivo como medio de pago.',
          'Pagos — carga una orden de pago con efectivo como medio de pago.',
        ],
      },
      {
        title: 'Agregar un movimiento (traspaso)',
        intro: 'Desde «Agregar movimiento» completá:',
        fields: [
          { label: 'Fecha', description: 'Día del movimiento.' },
          {
            label: 'Tipo de movimiento',
            description: 'Por ejemplo: de caja a caja, de caja a banco o de banco a caja, según las opciones disponibles.',
          },
          { label: 'Destino', description: 'La otra caja o la cuenta bancaria involucrada.' },
          {
            label: 'Monto',
            description: 'Importe a transferir. Si las monedas son distintas, completá el monto en origen y en destino.',
          },
        ],
      },
    ],
  },
}
